import { GO_LIVE_SITE,GO_LIVE_FILTER } from "./type";

const initalState = {
  liveSiteData: {},
  liveFilterDropDown: {}
};

const liveSiteDataReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GO_LIVE_SITE:
      return {
        ...state,
        liveSiteData: payload,
      };
      case GO_LIVE_FILTER:
      return {
        ...state,
        liveFilterDropDown: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default liveSiteDataReducer;
